module.exports = __webpack_public_path__ + "static/img/icon_partner_siemens.c6ce71e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_partner_siemens.png
// module id = Bv95
// module chunks = 1